<div class="overlay-window-header" [ngClass]="{'empty': isTitleEmpty && !customContent.elementRef, 'no-line': !bottomLine, 'no-backdrop': noBackdropFilter}">
  <div class="overlay-window-header__title" *ngIf="title && title.length > 0; else customContent;">{{title}}</div>
  <ng-template #customContent>
    <ng-content></ng-content>
  </ng-template>
  <button autofocus class="overlay-window-header__close" (click)="onClosed.emit(true)"><brt-icon [icon]="'burger-close'"></brt-icon></button>
</div>
